var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5C85A7",
    fillRule: "evenodd",
    d: "M9.8 9.8v-.7a.7.7 0 0 1 .7-.7h2.1v3.5a.7.7 0 0 1-.7.7H2.1a.7.7 0 0 1-.7-.7V8.4h2.1a.7.7 0 0 1 .7.7v.7a1.4 1.4 0 0 0 1.4 1.4h2.8a1.4 1.4 0 0 0 1.4-1.4zM8.4 8.4v1.4H5.6V8.4A1.4 1.4 0 0 0 4.2 7H1.4l1.12-5.6h8.96L12.6 7H9.8a1.4 1.4 0 0 0-1.4 1.4zM14 7L12.713.563A.7.7 0 0 0 12.026 0H1.974a.7.7 0 0 0-.687.563L0 7v5.6A1.4 1.4 0 0 0 1.4 14h11.2a1.4 1.4 0 0 0 1.4-1.4V7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon_email.87209a84d6a38e440b17539a13bde766.svg";
export { ForwardRef as ReactComponent };